import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, InputAdornment, TextField, Typography } from '@mui/material';
import clsx from 'clsx';
import { useBreakpoints } from 'hooks';

import { Button } from 'components/_basic/Button/Button';

import { IShareLinksFormProps as IProps } from './types';

import styles from './ShareLinksForm.module.scss';

export const ShareLinksForm: FC<IProps> = ({
  buttonText,
  label,
  endAdornmentText,
  register,
  onSubmit,
  isLoading = false,
  isButtonDisabled = false,
  error = '',
  isInputDisabled = false,
}) => {
  const { t } = useTranslation();
  const isFieldError = Boolean(error);
  const { isMobile } = useBreakpoints();

  return (
    <Box component="form" className={styles.form} onSubmit={onSubmit}>
      <Typography variant="subtitle2" className={clsx(styles.label, isFieldError && styles.red)}>
        {label}
      </Typography>
      <Box className={styles.inputRow}>
        <TextField
          {...register('email')}
          name="email"
          placeholder={t('email')}
          className={styles.input}
          error={isFieldError}
          disabled={isInputDisabled}
          InputProps={{
            endAdornment: endAdornmentText ? (
              <InputAdornment position="end">
                <Typography variant="body2" component="span">
                  {endAdornmentText}
                </Typography>
              </InputAdornment>
            ) : null,
          }}
        />
        <Button disabled={isButtonDisabled} isLoading={isLoading} type="submit" variant="contained" fullWidth={isMobile}>
          {buttonText}
        </Button>
      </Box>
      {isFieldError && (
        <Typography variant="subtitle2" className={styles.error}>
          {error}
        </Typography>
      )}
    </Box>
  );
};
